// Helpers visuais compartilhados (chips, painéis, badges, mini KPI).
import React from 'react';

export function PainelInfo({ titulo, children }: { titulo: string; children: React.ReactNode }) {
  return (
    <div style={{ background: '#fff', border: '0.5px solid #e0e0e0', borderRadius: 8, padding: 12 }}>
      <div style={{
        fontSize: 11, fontWeight: 700, color: '#888', letterSpacing: '0.06em',
        marginBottom: 10, paddingBottom: 6, borderBottom: '0.5px solid #f0f0f0',
      }}>{titulo}</div>
      {children}
    </div>
  );
}

export function Linha({ label, valor }: { label: string; valor: any }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', fontSize: 12 }}>
      <span style={{ flex: '0 0 110px', color: '#888' }}>{label}</span>
      <span style={{ flex: 1, color: '#222' }}>{valor}</span>
    </div>
  );
}

export function Chip({ children, cor = '#0930D0' }: { children: React.ReactNode; cor?: string }) {
  return <span style={{
    fontSize: 11, padding: '2px 8px', borderRadius: 3,
    background: `${cor}22`, color: cor, fontWeight: 500,
  }}>{children}</span>;
}

export function ChipUser({ children }: { children: React.ReactNode }) {
  return <span style={{
    display: 'inline-flex', alignItems: 'center', gap: 4,
    fontSize: 11, padding: '2px 8px', borderRadius: 3,
    background: '#F0F1F5', color: '#020D7F', fontWeight: 500,
  }}>👤 {children}</span>;
}

export function StatusBadge({ status }: { status: string }) {
  const c: Record<string, string> = { rascunho: '#B07500', enviada: '#0930D0', aprovada: '#0a7f4a' };
  return <span style={{ fontSize: 10, padding: '2px 8px', borderRadius: 3,
    background: `${c[status] || '#888'}22`, color: c[status] || '#888', fontWeight: 500 }}>
    {status}
  </span>;
}

export function Label({ children }: { children: React.ReactNode }) {
  return <label style={{ fontSize: 11, fontWeight: 600, color: '#555', display: 'block', marginBottom: 3 }}>{children}</label>;
}

export function Mini2({ valor, label, cor }: { valor: string; label: string; cor?: string }) {
  return (
    <div>
      <div style={{ fontSize: 18, fontWeight: 700, color: cor || '#020D7F' }}>{valor}</div>
      <div style={{ fontSize: 10, color: '#888', marginTop: 2 }}>{label}</div>
    </div>
  );
}
